"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get ApproveAllEasyAddResponse () {
        return ApproveAllEasyAddResponse;
    },
    get CloseReviewResponse () {
        return CloseReviewResponse;
    },
    get DeleteReviewByIdResponse () {
        return DeleteReviewByIdResponse;
    },
    get DeleteReviewReportByIdResponse () {
        return DeleteReviewReportByIdResponse;
    },
    get GetExternalReviewReportResponse () {
        return GetExternalReviewReportResponse;
    },
    get GetReviewByIdResponse () {
        return GetReviewByIdResponse;
    },
    get GetReviewReportAnswersByIdResponse () {
        return GetReviewReportAnswersByIdResponse;
    },
    get GetReviewReportByIdResponse () {
        return GetReviewReportByIdResponse;
    },
    get GetReviewReportsByReviewResponse () {
        return GetReviewReportsByReviewResponse;
    },
    get GetReviewsResponse () {
        return GetReviewsResponse;
    },
    get PatchReviewReportByIdResponse () {
        return PatchReviewReportByIdResponse;
    },
    get PatchReviewReportExternalAuthorByIdResponse () {
        return PatchReviewReportExternalAuthorByIdResponse;
    },
    get PostReviewReportByReviewResponse () {
        return PostReviewReportByReviewResponse;
    },
    get PostReviewResponse () {
        return PostReviewResponse;
    },
    get PutExternalReviewReportAnswersResponse () {
        return PutExternalReviewReportAnswersResponse;
    },
    get PutReviewByIdResponse () {
        return PutReviewByIdResponse;
    },
    get PutReviewReportAnswersByIdResponse () {
        return PutReviewReportAnswersByIdResponse;
    },
    get ReopenReviewResponse () {
        return ReopenReviewResponse;
    }
});
const _zod = require("zod");
const _models = require("@performyard/models");
const _utilsisomorphic = require("@performyard/utils-isomorphic");
const _reviewquestion = require("./questions/review-question");
const _review = require("./review");
const _reviewreport = require("./review-report");
const GetReviewReportsByReviewResponse = _zod.z.object({
    data: _zod.z.array(_reviewreport.ReviewReportWithoutContent),
    meta: _zod.z.object({
        success: _zod.z.literal(true),
        activeReportsCount: _zod.z.number(),
        awaitingApprovalCount: _zod.z.number()
    })
});
const GetReviewReportByIdResponse = _zod.z.object({
    data: _reviewreport.ReviewReport.and(_zod.z.object({
        sendBackContext: _reviewreport.ReviewReportSendBackContext.array(),
        questions: _reviewquestion.ReviewQuestion.array()
    })),
    meta: _zod.z.object({
        success: _zod.z.literal(true)
    })
});
const PostReviewReportByReviewResponse = _zod.z.object({
    data: _zod.z.array(_reviewreport.ReviewReportWithoutContent),
    meta: _zod.z.object({
        success: _zod.z.literal(true),
        pending: _zod.z.boolean(),
        activeReportsCount: _zod.z.number(),
        awaitingApprovalCount: _zod.z.number(),
        errors: _zod.z.boolean(),
        existingAuthorIds: _utilsisomorphic.transformObjectId.array()
    })
});
const PatchReviewReportByIdResponse = _zod.z.object({
    data: _reviewreport.ReviewReport,
    meta: _zod.z.object({
        success: _zod.z.literal(true)
    })
});
const DeleteReviewReportByIdResponse = _zod.z.object({
    meta: _zod.z.object({
        success: _zod.z.literal(true)
    })
});
//#region Reviews
const ReviewSuccessMeta = _zod.z.object({
    success: _zod.z.literal(true)
});
const SingleReviewResponse = _zod.z.object({
    data: _review.Review,
    meta: ReviewSuccessMeta
});
const GetReviewsResponse = _zod.z.object({
    data: _zod.z.array(_review.Review),
    meta: ReviewSuccessMeta.extend({
        pagination: _zod.z.object({
            skip: _zod.z.number(),
            limit: _zod.z.number(),
            total: _zod.z.number()
        })
    })
});
const GetReviewByIdResponse = SingleReviewResponse;
const PostReviewResponse = SingleReviewResponse;
const PutReviewByIdResponse = SingleReviewResponse;
const DeleteReviewByIdResponse = _zod.z.object({
    meta: ReviewSuccessMeta
});
const CloseReviewResponse = SingleReviewResponse;
const ReopenReviewResponse = SingleReviewResponse;
const ApproveAllEasyAddResponse = _zod.z.object({
    data: _zod.z.object({
        approvedCount: _zod.z.number()
    }),
    meta: _zod.z.object({
        success: _zod.z.literal(true)
    })
});
const GetReviewReportAnswersByIdResponse = _zod.z.object({
    data: (0, _utilsisomorphic.toCamelCaseSchema)(_zod.z.array(_models.ReviewReportAnswerModel.nullable())).optional(),
    meta: _zod.z.object({
        success: _zod.z.literal(true)
    })
});
const PutReviewReportAnswersByIdResponse = _zod.z.object({
    data: (0, _utilsisomorphic.toCamelCaseSchema)(_zod.z.array(_models.ReviewReportAnswerModel.nullable())).optional(),
    meta: _zod.z.object({
        success: _zod.z.literal(true)
    })
});
const GetExternalReviewReportResponse = _zod.z.object({
    data: _zod.z.object({
        _id: _utilsisomorphic.transformObjectId,
        questions: _reviewquestion.ReviewQuestion.array(),
        answers: (0, _utilsisomorphic.toCamelCaseSchema)(_zod.z.array(_models.ReviewReportAnswerModel.nullable())).optional(),
        submit: _zod.z.boolean(),
        externalAuthor: _reviewreport.ReviewReportExternalAuthor.nullable()
    }),
    meta: _zod.z.object({
        success: _zod.z.literal(true)
    })
});
const PutExternalReviewReportAnswersResponse = _zod.z.object({
    data: (0, _utilsisomorphic.toCamelCaseSchema)(_zod.z.array(_models.ReviewReportAnswerModel.nullable())).optional(),
    meta: _zod.z.object({
        success: _zod.z.literal(true)
    })
});
const PatchReviewReportExternalAuthorByIdResponse = _zod.z.object({
    data: _reviewreport.ReviewReportExternalAuthor,
    meta: _zod.z.object({
        success: _zod.z.literal(true)
    })
});
